/*
 * @Author: 朱占为
 * @LastEditors: 秦琛
 * @description: 应用状态管理
 * @Date: 2021-07-20 10:23:19
 */
import { createStore } from 'vuex';
import user from './modules/user'
import permission from './modules/permission'
import getters from './getters'
import pageCache from './modules/pageCache'
import edgeTask from "store/modules/edgeTask";
import cloudTask from "store/modules/cloudTask";
import deviceManagement from "store/modules/deviceManagement";
import dataSourceManagement from "store/modules/dataSourceManagement";
import taskManagement from "store/modules/taskManagement";
import uploadProgress from './modules/uploadProgress'
import alarmEventsManagement from './modules/alarmEventsManagement'
import alarmManagementPlus from './modules/alarmManagementPlus';

export const store = createStore({
  modules: {
    user,
    permission,uploadProgress,
    pageCache,
    edgeTask,
    cloudTask,
    deviceManagement,
    dataSourceManagement,
    taskManagement,
    alarmEventsManagement,
    alarmManagementPlus,
  },
  getters
});




export default function(app) {
  app.use(store);
}

